import { render, staticRenderFns } from "./SMSCampaignsListRoute.vue?vue&type=template&id=4fbafc07&scoped=true&"
import script from "./SMSCampaignsListRoute.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignsListRoute.vue?vue&type=script&lang=js&"
import style0 from "./SMSCampaignsListRoute.vue?vue&type=style&index=0&id=4fbafc07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbafc07",
  null
  
)

export default component.exports